import { encode } from 'querystring-es3'
const axios = require('axios')

export default {
  methods: {
    getSortenPflanzenkrankheiten (query) {
      console.log(query)
      query = encode({ query: window.btoa(JSON.stringify(query)) })
      return axios.post(axios.defaults.baseURL + 'api/Sorte/getSortenPflanzenkrankheiten/pwaCallSortenKrankheiten', query)
    }
  }
}
